import { styled, TableCell } from "@mui/material";

export const HeaderTableCell = styled(TableCell)(({ theme }) => {
    return {
        fontSize: 12,
        fontWeight: 500,
        color: theme.palette.customGrey.main
    };
})